import IconComponent from "icons/IconComponent";

import CalendarIcon from "./calendar-icon.svg";

export default (CalendarIcon as any) as IconComponent;
